import request from '@/http/axios'
import axios from 'axios'

// 企业设置
export function getEnterpriseSettingsApi(data) {
  return request({
    url: `/api/v1/enterprise/settings`,
    method: 'get',
    params: data,
  })
}

// 获取术语语料上传历史历表.
export function checkUserCreate(data) {
  return request({
    url: '/twinslator/user/checkUserCreate',
    method: 'get',
    params: data,
  })
}

// 获取术语语料上传历史历表.
export function uploadHistory(data) {
  return request({
    url: '/api/v1/term-corpus/upload-history',
    method: 'get',
    headers: { 'Content-Type': 'application/json' },
    params: data,
  })
}

// 删除术语语料导入结果.
export function deleteImportResult(data) {
  return request({
    url: '/api/v1/term-corpus/delete-import-result',
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  })
}

// 引擎-上线
export function executeOnline(data) {
  return request({
    url: '/twinslator/user/executeOnline',
    method: 'post',
    data,
  })
}

// 通过库导入术语语料.
export function importTermCorpus(data) {
  return request({
    url: '/api/v1/term-corpus/import',
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  })
}

// 查询术语导入导出结果
export function termCorpusRes(data) {
  return request({
    url: '/api/v1/term-corpus/import-result',
    method: 'get',
    headers: { 'Content-Type': 'application/json' },
    params: data,
  })
}

// 前往术语语料
export function toTermCorpus(data) {
  return request({
    url: '/pe7/translator/getTicket',
    method: 'post',
    data,
  })
}

// 文档快翻-添加术语
export function createTerm(data) {
  return request({
    url: '/pe7/projectGroup/library/entry/create',
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  })
}

// 文档快翻-库列表
export function getDocMtLibList(data) {
  return request({
    url: '/twinslator/mt/doc/getDocMtLibList',
    method: 'post',
    data,
  })
}

// 文档快翻-列表状态刷新
export function refreshDocTwinslatorMtStatus(data) {
  return request({
    url: '/twinslator/mt/doc/refreshDocTwinslatorMtStatus',
    method: 'post',
    data,
  })
}

// 文档快翻-列表
export function getDocMtTaskList(data) {
  return request({
    url: '/twinslator/mt/doc/getDocMtTaskList',
    method: 'post',
    data,
  })
}

// 文档快翻-导出
export function exportPersonalTranslateFiles(data) {
  return request({
    url: '/twinslator/mt/doc/startFileExport',
    method: 'post',
    data,
  })
}

// 文档快翻-导出刷新
export function getDocExportCacheList(data) {
  return request({
    url: '/pe7/projectGroup/document/getDocExportCacheList',
    method: 'post',
    data,
  })
}

// 文档快翻-删除
export function deleteTask(data) {
  return request({
    url: '/twinslator/mt/doc/deleteTask',
    method: 'post',
    data,
  })
}

// 文档快翻-预览-新
export function previewDocMtTaskNew(data) {
  return request({
    url: '/twinslator/mt/doc/previewDocMtTaskNew',
    method: 'post',
    data,
  })
}

// 自动检测源语种
export function getDocCharCountByCache(data) {
  return request({
    url: '/twinslator/mt/doc/getDocCharCountByCache',
    method: 'post',
    data,
  })
}

// 获取机翻列表
export function getAllTwinslators(data) {
  return request({
    url: '/twinslator/market/getAllTwinslators',
    method: 'post',
    data,
  })
}

// 获取引擎字数及费用
export function queryDocMtCostByCharCount(data) {
  return request({
    url: '/twinslator/mt/doc/queryDocMtCostByCharCount',
    method: 'post',
    data,
  })
}

// 字符统计，语种识别
export function getDocCharCount(data) {
  return request({
    url: '/twinslator/mt/doc/getDocCharCount',
    method: 'post',
    data,
  })
}

//获取Twinslator列表
export function getTwinslatorList(data) {
  return request({
    url: '/twinslator/market/getTwinslatorList',
    method: 'post',
    data,
  })
}

//获取Twinslator详情
export function getTwinslatorInfo(data) {
  return request({
    url: '/twinslator/market/getTwinslatorInfo',
    method: 'post',
    data,
  })
}

//获取Twinslator配置
export function getDictionary(data) {
  return request({
    url: '/twinslator/base/getDictionary',
    method: 'post',
    data,
  })
}

//登录
export function loginValidate(data) {
  return request({
    url: '/twinslator/cas/loginValidate',
    method: 'post',
    data,
  })
}

//退出
export function logout(data) {
  return request({
    url: '/twinslator/cas/logout',
    method: 'post',
    data,
  })
}

//收藏、取消收藏
export function favorite(data) {
  return request({
    url: '/twinslator/market/favorite',
    method: 'post',
    data,
  })
}

//收藏列表
export function favoriteList(data) {
  return request({
    url: '/twinslator/market/getFavoriteListByCondition',
    method: 'post',
    data,
  })
}

//我的列表
export function getMyListByCondition(data) {
  return request({
    url: '/twinslator/user/getMyListByCondition',
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  })
}

//样例翻译
export function mtCaseTranslate(data) {
  return request({
    url: '/twinslator/market/mtCaseTranslate',
    method: 'post',
    data,
  })
}

//获取七牛token
export function getNewUploadToken(data) {
  return request({
    url: '/twinslator/base/getNewUploadToken',
    method: 'post',
    data,
  })
}

//上传
export function uploadFile(url, data) {
  return request({
    url: url,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: data,
  })
}

//立即翻译
export function createDocMtTryTranslationTask(data) {
  return request({
    url: '/twinslator/mt/doc/createDocMtTryTranslationTask',
    method: 'post',
    data,
  })
}

//文档机翻--下单
export function createDocMtTask(data) {
  return request({
    url: '/twinslator/mt/doc/createDocMtTask',
    method: 'post',
    data,
  })
}

//文档机翻--轮训状态
export function refreshTaskStatus(data) {
  return request({
    url: '/twinslator/mt/doc/refreshTwinslatorStatus',
    method: 'post',
    data,
  })
}

//文档机翻--预览接口
export function previewDocMtTask(data) {
  return request({
    url: '/twinslator/mt/doc/previewDocMtTask',
    method: 'post',
    data,
  })
}

//文档机翻--跳转webcat
export function getTranslateUrl(data) {
  return request({
    url: '/twinslator/task/getTranslateUrl',
    method: 'post',
    data,
  })
}

//文档机翻--导出译稿
export function startFileExport(data) {
  return request({
    url: '/twinslator/mt/doc/startFileExport',
    method: 'post',
    data,
  })
}

//文档机翻--完成试译
export function finishTryTranslationTask(data) {
  return request({
    url: '/twinslator/mt/doc/finishTryTranslationTask',
    method: 'post',
    data,
  })
}

//文档机翻--获取机翻评分
export function getScore(data) {
  return request({
    url: '/twinslator/market/getScore',
    method: 'post',
    data,
  })
}

//文档机翻--机翻评分
export function addScore(data) {
  return request({
    url: '/twinslator/market/addScore',
    method: 'post',
    data,
  })
}

// 校验token是否过期
export function checkToken(data) {
  return request({
    url: '/twinslator/cas/info',
    method: 'get',
  })
}

// 文本翻译-原语种自动检查
export function checkSourText(data) {
  return request({
    url: '/twinslator/nlp/textRecognition',
    method: 'POST',
    data,
  })
}

//自定义引擎列表、
export function enginesList(data) {
  return request({
    url: '/twinslator/info/listOfTextTranslationEngines',
    method: 'POST',
    data,
  })
}

//文本翻译-翻译
export function textTranslation(data) {
  return request({
    url: '/twinslator/info/textTranslation',
    method: 'POST',
    data,
  })
}

//创建Twinslator
export function create(data) {
  return request({
    url: '/twinslator/user/create',
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  })
}

//获取引擎看板统计信息
export function statAll(data) {
  return request({
    url: '/twinslator/dashboard/stat-all',
    method: 'get',
    params: data,
  })
}

//获取引擎调用次数及翻译字数
export function statCallWordCount(data) {
  return request({
    url: '/twinslator/dashboard/stat-call-word-count',
    method: 'get',
    params: data,
  })
}

//获取引擎加入人数及加入语料数
export function statPersonCorpusNum(data) {
  return request({
    url: '/twinslator/dashboard/stat-person-corpus-num',
    method: 'get',
    params: data,
  })
}

//获取引擎收益列表
export function engineEarningList(data) {
  return request({
    url: '/twinslator/dashboard/engine-earning-list',
    method: 'get',
    params: data,
  })
}

/**
 * 【8.22.0】获取文件上传token new
 * @param  {
 * }
 */
export function getUploadTokenNew(data) {
  return request({
    url: `/api/v1/file/token`,
    method: 'post',
    data,
  })
}

/**
 * 【8.22.0】上传文件 new
 * @param  {
 * }
 */
export function uploadFileNew(url, headers, data) {
  return axios({
    url: url,
    method: 'put',
    headers,
    data,
  })
}

//获取消息提醒
export function countallUnRead(data) {
  return request({
    url: '/api/v1/message/count_unread',
    method: 'get',
    params: data,
  })
}

/**
 * 【8.45.0】文本翻译-差异对比
 * @param  {
 * }
 */
export function diffCompare(data) {
  return request({
    url: `/twinslator/text/diffCompare`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  })
}

/**
 * 【8.45.0】文本翻译-推荐引擎
 * @param  {
 * }
 */
export function getRecommendTwinslators(data) {
  return request({
    url: `/twinslator/text/getRecommendTwinslators`,
    method: 'post',
    data,
  })
}

/**
 * 【8.45.0】文本翻译-翻译
 * @param  {
 * }
 */
export function textTranslationNew(data) {
  return request({
    url: '/twinslator/info/mt/text',
    method: 'POST',
    data,
  })
}

//引擎榜单top5
export function twinslatorRank(data) {
  return request({
    url: '/twinslator/rank',
    method: 'get',
    data,
  })
}

//banner list
export function getBannerList(data) {
  return request({
    url: '/twinslator/base/banner/list',
    method: 'post',
    data,
  })
}

//合作咨询
export function postConsultationSeek(data) {
  return request({
    url: '/twinslator/consult',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/json' },
  })
}

///获取选择语种下拉框数据
export function postMarketLangList(data) {
  return request({
    url: '/twinslator/market/getMarketLangList',
    method: 'post',
    data,
  })
}

//分享链接
export function shareTwLinkId(data) {
  return request({
    url: '/twinslator/market/share',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/json' },
  })
}

//申请公开
export function applyOpen(data) {
  return request({
    url: '/twinslator/user/applyOpen',
    method: 'post',
    data,
  })
}

/**
 * 【8.51.0】引擎删除
 * @param  {
 * }
 */
export function deleteMt(data) {
  return request({
    url: '/twinslator/user/delete',
    method: 'post',
    data,
  })
}

/**
 * 【8.52.0】文本翻译-机翻重试
 * @param  {
 * }
 */
export function retryDocMtPreprocess(data) {
  return request({
    url: '/twinslator/mt/doc/retryDocMtPreprocess',
    method: 'post',
    data,
  })
}

/**
 * 【8.52.0】个人任务-文档退费
 * @param  {
 * }
 */
export function refundDocTask(data) {
  return request({
    url: '/twinslator/mt/doc/refundDocTask',
    method: 'post',
    data,
  })
}

/**
 * 【8.52.0】数据看板-引擎汇总信息
 * @param  {
 * }
 */
export function getTwinslatorDataDeatil(data) {
  return request({
    url: '/twinslator/market/getTwinslatorDataDeatil',
    method: 'post',
    data,
  })
}

/**
 * 【8.52.0】数据看板-引擎翻译数据
 * @param  {
 * }
 */
export function getTwinslatorDataTranslate(data) {
  return request({
    url: '/twinslator/market/getTwinslatorDataTranslate',
    method: 'post',
    data,
  })
}

/**
 * 【8.52.0】数据看板-引擎调用数据
 * @param  {
 * }
 */
export function getTwinslatorDataUseCount(data) {
  return request({
    url: '/twinslator/market/getTwinslatorDataUseCount',
    method: 'post',
    data,
  })
}

/**
 * 【8.52.0】数据看板-引擎收入详情
 * @param  {
 * }
 */
export function getTwinslatorIncomeDetail(data) {
  return request({
    url: '/twinslator/market/getTwinslatorIncomeDetail',
    method: 'post',
    data,
  })
}

/**
 * 【8.52.0】数据看板-引擎收入明细列表
 * @param  {
 * }
 */
export function getTwinslatorIncomeDetailList(data) {
  return request({
    url: '/twinslator/market/getTwinslatorIncomeDetailList',
    method: 'post',
    data,
  })
}
// 数据看板-引擎共建列表
export function getTwinslatorCoBuildingList(data) {
  return request({
    url: '/twinslator/market/getTwinslatorCoBuildingList',
    method: 'post',
    data,
  })
}

//检查是否有权限访问引擎
export function postCheckEngineRoleType(data) {
  return request({
    url: '/api/engine/check',
    method: 'get',
    params: data,
    isClearBearer: true,
  })
}

//上传数据 批量

export function postSubmitFiles(data) {
  return request({
    url: '/api/engine/data/submit',
    method: 'post',
    params: data,
    isClearBearer: true,
  })
}

// 七牛云上传获取token、key、file
export const getQiNiuToken = (path) =>
  request({
    method: 'get',
    url: `/api/file/${path}/token`,
    isClearBearer: true,
  })

// 上传
export const updateFile = (data) => {
  return request({
    method: 'post',
    url: 'https://upload-z2.qiniup.com',
    data: data,
    headers: { 'Content-Type': 'multipart/form-data' },
    isClearBearer: true,
  })
}

//提交语料提交文件
export const postSubmitAllFiles = (data) => {
  return request({
    method: 'post',
    url: '/api/engine/data/submit',
    data: data,
    isClearBearer: true,
    headers: { 'Content-Type': 'application/json' },
  })
}

//查询提交结果
export const getSubmitFilesResult = (data) => {
  return request({
    method: 'get',
    url: `/api/engine/data/result`,
    isClearBearer: true,
    params: data,
  })
}

//获取上传历史记录

export const getFilesHistoryResult = (data) => {
  return request({
    method: 'get',
    url: `/api/engine/data/listpage`,
    isClearBearer: true,
    params: data,
  })
}

//获取共建引擎详情
export const getEngineInfo = (data) => {
  return request({
    method: 'get',
    url: `/api/engine/info`,
    isClearBearer: true,
    params: data,
  })
}

// 企业列表
export function getEnterpriseJoinList(data) {
  return request({
    method: 'get',
    url: `/twinslator/enterprise/join`,
    params: data,
  })
}

// 切换企业
export function switchEnterprise(data) {
  return request({
    url: '/twinslator/enterprise/switch',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/json' },
  })
}

// 用户译力信息
export function getEtoken(data) {
  return request({
    method: 'get',
    url: `/twinslator/cas/getEtoken`,
    params: data,
  })
}

// 文档快翻权限
export function checkDocMtAuthority(data) {
  return request({
    method: 'get',
    url: `/twinslator/mt/doc/checkDocMtAuthority`,
    params: data,
  })
}

// 机翻计费接口
export function checkTextCalculate(data) {
  return request({
    method: 'post',
    url: `/twinslator/text/calculate`,
    data: data,
    headers: { 'Content-Type': 'application/json' },
  })
}

// 获取最大会员等级
export function userLevelPrivilege(data) {
  return request({
    method: 'get',
    url: `/api/v1/user/current/level-privilege`,
    params: data,
    headers: { 'Content-Type': 'application/json' },
  })
}

//获取字典
export function getUserGetDict(data) {
  return request({
    method: 'get',
    url: `/api/v1/user/get_dict`,
    params: data,
    headers: { 'Content-Type': 'application/json' },
  })
}

//设置字典
export function setUserGetDict(data) {
  return request({
    method: 'post',
    url: `/api/v1/user/set_dict`,
    data: data,
    headers: { 'Content-Type': 'application/json' },
  })
}

//是否登录
export function checkLoginApi(data) {
  return request({
    method: 'get',
    url: `/twinslator/cas/checkLogin`,
  })
}

export function getDocTranslateLib(data) {
  return request({
    url: '/twinslator/mt/doc/getDocMtLibs',
    method: 'post',
    data,
  })
}

//保存引擎大模型提示词配置
export function postTwinslatorPromptSave(data) {
  return request({
    url: '/twinslator/prompt/save',
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  })
}

//删除提示词配置
export function postTwinslatorPromptDelete(id) {
  return request({
    url: '/twinslator/prompt/delete?twinslatorId=' + id,
    method: 'post',
  })
}

/**
 * 文件解压-1201-Vnacos
 */
export const fileDecompress = (params) => {
  return request({
    url: '/twinslator/mt/doc/file_decompress',
    method: 'get',
    params,
  })
}

//批量获取文档字符数
export function batchDocCharCountByCache(data) {
  return request({
    method: 'post',
    url: `/twinslator/mt/doc/batchDocCharCountByCache`,
    data: data,
    headers: { 'Content-Type': 'application/json' },
  })
}
